import React from 'react';
import { Link, useLocation } from 'react-router-dom';

export function PageNotFound() {
  return <section className="mx-auto max-w-xl p-6 py-16">
    <h1 className="text-2xl font-semibold text-slate-950">Page not found</h1>
    <p className="mt-3 text-slate-600">This address does not match a page in your workspace.</p>
    <Link to="/" className="mt-6 inline-flex min-h-11 items-center rounded-lg bg-slate-950 px-4 text-sm font-semibold text-white">Go to dashboard</Link>
  </section>;
}

class PageErrorBoundary extends React.Component {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  componentDidCatch(error, info) { console.error('Page failed to render', error, info); }
  render() {
    if (!this.state.failed) return this.props.children;
    return <section role="alert" className="mx-auto max-w-xl p-6 py-16">
      <h1 className="text-2xl font-semibold text-slate-950">Unable to open this page</h1>
      <p className="mt-3 text-slate-600">Reload to try again, or return to your dashboard.</p>
      <div className="mt-6 flex flex-wrap gap-3">
        <button className="min-h-11 rounded-lg bg-slate-950 px-4 text-sm font-semibold text-white" onClick={() => window.location.reload()}>Reload page</button>
        <Link to="/" className="inline-flex min-h-11 items-center rounded-lg border border-slate-300 px-4 text-sm font-semibold">Go to dashboard</Link>
      </div>
    </section>;
  }
}

export function RouteRecovery({ children }) {
  const location = useLocation();
  return <PageErrorBoundary key={location.pathname}>{children}</PageErrorBoundary>;
}
